module.exports = __webpack_public_path__ + "static/img/fgbg2-10.25dab85.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-10.png
// module id = 201
// module chunks = 0